import React from 'react'
import ImageTiles from '../ImageTiles'
import InteractiveDatetime from '../../InteractiveDatetime'

const Header = ({ listing, product }) => (
  <div className="item-header">
    <ImageTiles images={product.images} />
    <h5 className="drawer-header" style={{ marginBottom: 0, lineHeight: 1.4 }}>
      {listing.categoryPath}
    </h5>
    <h2 style={{ marginTop: 5 }}>{listing.title}</h2>
    <div className="details">
      <div className="bp3-text-muted">Posted by: {product.user.username}</div>
      <InteractiveDatetime value={listing.createdAt} />
    </div>
  </div>
)
export default Header
